import { config } from "../../config/config";
import { i18n } from "../../services/i18nService";
import { normalizeLang } from "../PlayerBitmovin/bitmovinErrorMapper";
const getTrackLanguages = () => {
  return {
    TEXT: {
      off: i18n.get("pages.player.tracks.none"),
      en: i18n.get("global.subtitleLanguages.en"),
      ar: i18n.get("global.subtitleLanguages.ar"),
      fr: i18n.get("global.subtitleLanguages.fr"),
      tur: i18n.get("global.languages.tur"),
      tr: i18n.get("global.languages.tr"),
      zh: i18n.get("global.languages.zh"),
      zho: i18n.get("global.languages.zho"),
      mn: i18n.get("global.languages.mn"),
      mon: i18n.get("global.languages.mon"),
      kk: i18n.get("global.languages.kk"),
      kaz: i18n.get("global.languages.kaz"),
      bn: i18n.get("global.languages.bn"),
      ben: i18n.get("global.languages.ben"),
      mr: i18n.get("global.languages.mr"),
      mar: i18n.get("global.languages.mar"),
      hi: i18n.get("global.languages.hi"),
      hin: i18n.get("global.languages.hin"),
      te: i18n.get("global.languages.te"),
      tel: i18n.get("global.languages.tel"),
      kn: i18n.get("global.languages.kn"),
      kan: i18n.get("global.languages.kan"),
      ta: i18n.get("global.languages.ta"),
      tam: i18n.get("global.languages.tam"),
      ml: i18n.get("global.languages.ml"),
      mal: i18n.get("global.languages.mal"),
      ur: i18n.get("global.languages.ur"),
      urd: i18n.get("global.languages.urd"),
      de: i18n.get("global.languages.de"),
      deu: i18n.get("global.languages.de"),
      ger: i18n.get("global.languages.de")
    },
    AUDIO: {
      en: i18n.get("global.languages.en"),
      ar: i18n.get("global.languages.ar"),
      fr: i18n.get("global.languages.fr"),
      jpn: i18n.get("global.languages.jp"),
      ja: i18n.get("global.languages.jp"), // bitmovin player return 'ja' for japanses instead of 'jpn' or 'jp'
      kor: i18n.get("global.languages.kor"),
      tur: i18n.get("global.languages.tur"),
      tr: i18n.get("global.languages.tr"),
      ur: i18n.get("global.languages.ur"),
      fa: i18n.get("global.languages.fa"),
      zh: i18n.get("global.languages.zh"),
      zho: i18n.get("global.languages.zho"),
      mn: i18n.get("global.languages.mn"),
      mon: i18n.get("global.languages.mon"),
      kk: i18n.get("global.languages.kk"),
      kaz: i18n.get("global.languages.kaz"),
      bn: i18n.get("global.languages.bn"),
      ben: i18n.get("global.languages.ben"),
      mr: i18n.get("global.languages.mr"),
      mar: i18n.get("global.languages.mar"),
      hi: i18n.get("global.languages.hi"),
      hin: i18n.get("global.languages.hin"),
      te: i18n.get("global.languages.te"),
      tel: i18n.get("global.languages.tel"),
      kn: i18n.get("global.languages.kn"),
      kan: i18n.get("global.languages.kan"),
      ta: i18n.get("global.languages.ta"),
      tam: i18n.get("global.languages.tam"),
      ml: i18n.get("global.languages.ml"),
      mal: i18n.get("global.languages.mal"),
      ur: i18n.get("global.languages.ur"),
      urd: i18n.get("global.languages.urd"),
      de: i18n.get("global.languages.de"),
      deu: i18n.get("global.languages.de"),
      ger: i18n.get("global.languages.de")
    }
  };
};

export const disabledTracks = "off";

export function getLocales() {
  return config.get().locales;
}
export function getDefaultLocale() {
  return config.get().sdk.defaultLocale;
}

/**
 * Adds title and selected properties to each of the track objects received as a parameter.
 * @param {Array<Track>} tracks The list of track object to be extended with new properties.
 * @returns {Array<Track>}  A new list containing the original parameters and the new ones on each track.
 */
export function extendTrackInfo(tracks = [], preferredLang, isFromBitmovin = false) {
  const trackLanguages = getTrackLanguages();
  let selectedIndex;
  if (isFromBitmovin) {
    const finalIndex = tracks.findIndex(track => normalizeLang(track.lang || track.language) === preferredLang);
    selectedIndex = finalIndex === -1 ? tracks.length - 1 : finalIndex;
  } else {
    selectedIndex = Math.max(
      tracks.findIndex(track => normalizeLang(track.lang || track.language) === preferredLang),
      0
    ); // Default value if the preferred language not present in the list
  }

  return tracks.map((track, index) => ({
    ...track,
    title: trackLanguages[track.type][track.lang || track.language] || track.language,
    selected: index === selectedIndex
  }));
}

/**
 * Loops the tracks list and updates the selected property of all of them, settings selected to true only to the
 * selectedTrack
 * @param {Array<Track>} tracks List of the tracks to be updated
 * @param {Track} selectedTrack The track that needs to be marked as selected
 * @returns {Array<Track>}  A new list of tracks whose selected track corresponds to selectedTrack parameter
 */
export function updateTracksState(tracks, selectedTrack) {
  return tracks.map(track => {
    track.selected = track.index === selectedTrack.index;
    return track;
  });
}
